var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23028_191440",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23028_191440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 19V6L20 12.5L6 19ZM7.22011 16.9828L16.859 12.5L7.22011 8.01724V11.3275L11.6312 12.5L7.22011 13.6725V16.9828Z",
    fill: "#2B2F38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.4f6d18fb0d5f4c6974cefb9ed4600893.svg";
export { ForwardRef as ReactComponent };